module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","eventOverview":"Schulungsübersicht"},"en":{"add":"Add","eventOverview":"Event overview"}}')
  delete Component.options._Ctor
}
